export default class KnownInternalNames {
    static Exchanges = class {
        public static readonly Coinbase: string = "COINBASE";

        public static readonly Coinspot: string = "COINSPOT";

        public static readonly Gateio: string = "GATEIO";

        public static readonly Binance: string = "BINANCE";

        public static readonly Kucoin: string = "KUCOIN";

        public static readonly Huobi: string = "HUOBI";

        public static readonly FtxUs: string = "FTXUS";

        public static readonly FtxCom: string = "FTXCOM";

        public static readonly Okex: string = "OKEX";

        public static readonly Bitfinex: string = "BITFINEX";

        public static readonly Kraken: string = "KRAKEN";

        public static readonly Bittrex: string = "BITTREX";

        public static readonly CryptoCom: string = "CRYPTOCOM";

        public static readonly CryptoComApp: string = "CRYPTOCOMAPP";

        public static readonly BinanceUS: string = "BINANCEUS";

        public static readonly Blocktane: string = "BLOCKTANE";

        public static readonly MexcGlobal: string = "MEXC";
    }

    static Networks = class {
        public static readonly CronosMainnet: string = "CRONOS_MAINNET";

        public static readonly OsmosisMainnet: string = "OSMOSIS_MAINNET";

        public static readonly ArbitrumMainnet: string = "ARBITRUM_MAINNET";

        public static readonly ArbitrumNova: string = "ARBITRUMNOVA_MAINNET";

        public static readonly ArbitrumRinkeby: string = "ARBITRUM_RINKEBY";

        public static readonly ArbitrumGoerli: string = "ARBITRUM_GOERLI";

        public static readonly ArbitrumSepolia: string = "ARBITRUM_SEPOLIA";

        public static readonly ModMainnet: string = "MODE_MAINNET";

        public static readonly OptimismMainnet: string = "OPTIMISM_MAINNET";

        public static readonly OptimismGoerli: string = "OPTIMISM_GOERLI";

        public static readonly OptimismKovan: string = "OPTIMISM_KOVAN";

        public static readonly RoninMainnet: string = "RONIN_MAINNET";

        public static readonly BobaMainnet: string = "BOBA_MAINNET";

        public static readonly BobaRinkeby: string = "BOBA_RINKEBY";

        public static readonly ZksyncMainnet: string = "ZKSYNC_MAINNET";

        public static readonly ZksyncEraMainnet: string = "ZKSYNCERA_MAINNET";

        public static readonly ZkspaceMainnet: string = "ZKSPACE_MAINNET";

        public static readonly ZksyncRinkeby: string = "ZKSYNC_RINKEBY";

        public static readonly EthereumRinkeby: string = "ETHEREUM_RINKEBY";

        public static readonly EthereumMainnet: string = "ETHEREUM_MAINNET";

        public static readonly EthereumGoerli: string = "ETHEREUM_GOERLI";

        public static readonly EthereumSepolia: string = "ETHEREUM_SEPOLIA";

        public static readonly PolygonMainnet: string = "POLYGON_MAINNET";

        public static readonly LoopringMainnet: string = "LOOPRING_MAINNET";

        public static readonly LoopringGoerli: string = "LOOPRING_GOERLI";

        public static readonly LoopringSepolia: string = "LOOPRING_SEPOLIA";

        public static readonly MoonbeamMainnet: string = "MOONBEAM_MAINNET";

        public static readonly StarkNetGoerli: string = "STARKNET_GOERLI";

        public static readonly StarkNetMainnet: string = "STARKNET_MAINNET";

        public static readonly StarkNetSepolia: string = "STARKNET_SEPOLIA";

        public static readonly ImmutableXMainnet: string = "IMMUTABLEX_MAINNET";

        public static readonly ImmutableXGoerli: string = "IMMUTABLEX_GOERLI";

        public static readonly ImmutableXSepolia: string = "IMMUTABLEX_SEPOLIA";

        public static readonly ImmutableZkEVM: string = "IMMUTABLEZK_MAINNET";

        public static readonly AstarMainnet: string = "ASTAR_MAINNET";

        public static readonly NahmiiMainnet: string = "NAHMII_MAINNET";

        public static readonly RhinoFiMainnet: string = "RHINOFI_MAINNET";

        public static readonly DydxMainnet: string = "DYDX_MAINNET";

        public static readonly DydxGoerli: string = "DYDX_GOERLI";

        public static readonly BNBChainMainnet: string = "BSC_MAINNET";

        public static readonly SolanaMainnet: string = "SOLANA_MAINNET";

        public static readonly SolanaTestnet: string = "SOLANA_TESTNET";

        public static readonly SolanaDevnet: string = "SOLANA_DEVNET";

        public static readonly SoonMainnet: string = "SOON_MAINNET";

        public static readonly SoonTestnet: string = "SOON_TESTNET";

        public static readonly SorareStage: string = "SORARE_MAINNET";

        public static readonly KCCMainnet: string = "KCC_MAINNET";

        public static readonly OKCMainnet: string = "OKC_MAINNET";

        public static readonly PolygonZkMainnet: string = "POLYGONZK_MAINNET";

        public static readonly LineaMainnet: string = "LINEA_MAINNET";

        public static readonly BaseMainnet: string = "BASE_MAINNET";

        public static readonly BaseTestnet: string = "BASE_TESTNET";

        public static readonly AvalancheMainnet: string = "AVAX_MAINNET";

        public static readonly PGNMainnet: string = "PGN_MAINNET";

        public static readonly PGNTestnet: string = "PGN_TESTNET";

        public static readonly MantleMainnet: string = "MANTLE_MAINNET";

        public static readonly ZoraMainnet: string = "ZORA_MAINNET";

        public static readonly RolluxMainnet: string = "ROLLUX_MAINNET";

        public static readonly OpBNBMainnet: string = "OPBNB_MAINNET";

        public static readonly MantaMainnet: string = "MANTA_MAINNET";

        public static readonly ScrollMainnet: string = "SCROLL_MAINNET";

        public static readonly TONMainnet: string = "TON_MAINNET";

        public static readonly TONTestnet: string = "TON_TESTNET";

        public static readonly BrineMainnet: string = "BRINE_MAINNET";

        public static readonly BlastSepolia: string = "BLAST_SEPOLIA";

        public static readonly BlastMainnet: string = "BLAST_MAINNET";

        public static readonly ParadexTestnet: string = "PARADEX_TESTNET"

        public static readonly ParadexMainnet: string = "PARADEX_MAINNET"

        public static readonly FuelMainnet: string = "FUEL_MAINNET"

        public static readonly FuelTestnet: string = "FUEL_TESTNET"

        public static readonly FuelDevnet: string = "FUEL_DEVNET"

        public static readonly TronMainnet: string = "TRON_MAINNET"

        public static readonly TronTestnet: string = "TRON_TESTNET"

        public static readonly EclipseTestnet: string = "ECLIPSE_TESTNET"

        public static readonly EclipseMainnet: string = "ECLIPSE_MAINNET"

        public static readonly SophonMainnet: string = "SOPHON_MAINNET"

        public static readonly SophonSepolia: string = "SOPHON_SEPOLIA"

        public static readonly RedStoneMainnet: string = "REDSTONE_MAINNET"

        public static readonly SoneiumMainnet: string = "SONEIUM_MAINNET"

        public static readonly BitcoinMainnet: string = "BITCOIN_MAINNET"

        public static readonly BitcoinTestnet: string = "BITCOIN_TESTNET"

        public static readonly ZircuitMainnet: string = "ZIRCUIT_MAINNET"

        public static readonly HyperliquidMainnet: string = "HYPERLIQUID_MAINNET"

        public static readonly HyperliquidTestnet: string = "HYPERLIQUID_TESTNET"

    }

    static Currencies = class {
        public static readonly USDT: string = "USDT";
        public static readonly ETH: string = "ETH";
        public static readonly USDC: string = "USDC";
        public static readonly USDCe: string = "USDC.e";
        public static readonly USDCE: string = "USDC.E";
        public static readonly LRC: string = "LRC";
        public static readonly IMX: string = "IMX";
        public static readonly SNX: string = "SNX";
        public static readonly ZKS: string = "ZKS";
    }

    static LiquidityProviders = class {
        public static readonly ConnextId: string = "39BF4D10-0AF8-4F54-A8B1-4C69A81ACA14".toLowerCase();

        public static readonly LayerSwapId: string = "168D5457-05ED-46E3-AAB3-72A2D2098F0F".toLowerCase();

        public static readonly StarkNetId: string = "fa3f93eb-9fea-44f3-a8a6-a5ced0f6d646".toLowerCase();
    }
}